import ReactDOM from 'react-dom';
import { v4 as generateId } from 'uuid';
import { Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { Store } from 'redux';

import { removeById } from 'src/tools/dom.tools';

import { store as globalStore } from 'src/store';
import { history } from 'src/routes/history';
import { ModalWrap } from 'src/components/Modal/ModalWrap';

interface Props {
  content: JSX.Element;
  onClose?: () => void;
  isCloseOnBackdrop?: boolean;
  store?: Store;
}

export function showModal({ content, onClose, store = globalStore, isCloseOnBackdrop = true }: Props) {
  if (!content) return;

  const id = generateId();

  function handleClose() {
    removeById(id);

    if (onClose) onClose();
  }

  function handleSetVisibility(isVisible: boolean) {
    if (!child) return;

    if (isVisible) child.classList.remove('d-none');
    else child.classList.add('d-none');
  }

  const root = document.getElementById('modal') as HTMLElement;

  const child = document.createElement('div');

  child.setAttribute('id', id);

  root.appendChild(child);

  history.listen((location, action) => {
    if (action) {
      handleClose();
    }
  });

  ReactDOM.render(
    <Provider store={store}>
      <Router history={history}>
        <ModalWrap onClose={handleClose} setVisibility={handleSetVisibility} isCloseOnBackdrop={isCloseOnBackdrop}>
          {content}
        </ModalWrap>
      </Router>
    </Provider>,
    child as HTMLElement,
  );
}
